// src/components/common/LanguageSwitcher.tsx

import { useParams, useLocation, useNavigate } from 'react-router-dom';

function LanguageSwitcher() {
  const { lang } = useParams<{ lang: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLanguageChange = (newLang: string) => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(`/${lang}`, `/${newLang}`);
    navigate(newPath);
  };

  return (
    <div className="language-switcher flex items-center">
      <button
        onClick={() => handleLanguageChange('vi')}
        disabled={lang === 'vi'}
        className={`px-2 py-1 text-sm rounded-md transition-colors ${
          lang === 'vi'
            ? 'font-bold text-gray-900 cursor-default'
            : 'font-medium text-gray-500 hover:text-gray-900'
        }`}
      >
        VI
      </button>
      
      <div className="h-4 w-px bg-gray-300 mx-1"></div>

      <button
        onClick={() => handleLanguageChange('en')}
        disabled={lang === 'en'}
        className={`px-2 py-1 text-sm rounded-md transition-colors ${
          lang === 'en'
            ? 'font-bold text-gray-900 cursor-default'
            : 'font-medium text-gray-500 hover:text-gray-900'
        }`}
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSwitcher;